<template>
	<div class="new-message">
		<form @submit.prevent="addMessage">
			<label for="new-message">New Message (enter to add):</label>
			<input type="text" name="new-message" v-model="newMessage" />
			<p class="red-text" v-if="feedback">{{ feedback }}</p>
		</form>
	</div>
</template>

<script>
import db from '@/firebase/init'

export default {
	name: "NewMessage",
	props: { name },
	data() {
		return {
			newMessage: null,
			feedback: null
		}
	},
	methods: {
		addMessage() {
			if (!this.newMessage) {
				this.feedback = "You must enter a message!"
				return
			}
			this.feedback = null

			this.newMessage = this.newMessage.charAt(0).toUpperCase() + this.newMessage.slice(1)

			db.collection("messages").add({
				content: this.newMessage,
				name: this.name,
				timestamp: Date.now()
			})
				.catch(err => console.err(error))

			this.newMessage = null
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/NewMessage.vue